module.exports = __webpack_public_path__ + "img/icon_map_4_off_011.e0790418.png";